import { HttpHeaders } from '@angular/common/http';
import { CachedHeader } from '../classes/cached-request';

export class HttpUtilities {
    public static createHttpHeader(cachedHeader: CachedHeader | undefined): HttpHeaders {
        let newHeader = new HttpHeaders();
        if (cachedHeader) {
            Object.keys(cachedHeader).forEach((name) => {
                const cachedHeaderName: string | string[] = cachedHeader[name];
                if (cachedHeader && cachedHeaderName) {
                    newHeader = newHeader.set(name, cachedHeaderName);
                }
            });
        }
        return newHeader;
    }
}
